/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import { apilogin, apismsvalid, apisystemsettingByCode } from '@/api';
import { mapState, mapActions, mapMutations } from 'vuex';
export default {
  components: {
    XButton: XButton
  },
  data: function data() {
    return {
      remember: true,
      type: 2,
      phone: '',
      password: '',
      verify_code: '',
      loading: false,
      wait: 61,
      clear: '',
      epImg: ''
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['user', 'appointInfo', 'Authorization', 'openid'])),
  created: function created() {
    var _this = this;
    var user = localStorage.getItem('user');
    if (user) {
      var data = JSON.parse(user);
      this.phone = data.phone || '';
      this.password = data.password || '';
    }
    apisystemsettingByCode({
      code: '40008'
    }).then(function (res) {
      if (res.success) {
        _this.epImg = res.data.value;
      }
    });
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions('globalStore', ['_ApiSession'])), mapMutations('globalStore', ['_appointInfo', '_Authorization'])), {}, {
    // 表单验证
    formValidate: function formValidate() {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        if (_this2.phone === '') {
          resolve({
            success: false,
            msg: i18n.tc("172")
          });
        }
        if (!_this2.checkPhone(_this2.phone)) {
          resolve({
            success: false,
            msg: i18n.tc("173")
          });
        }
        if (_this2.type === 1 && _this2.password === '') {
          resolve({
            success: false,
            msg: i18n.tc("174")
          });
        }
        if (_this2.type === 2 && _this2.verify_code === '') {
          resolve({
            success: false,
            msg: i18n.tc("177")
          });
        }
        resolve({
          success: true
        });
      });
    },
    // 登录
    login: function login() {
      var _this3 = this;
      this.formValidate().then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var res, _this3$$route, _this3$$route$query;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid.success) {
                    _context.next = 18;
                    break;
                  }
                  _this3.loading = true;
                  _context.next = 4;
                  return apilogin({
                    type: _this3.type,
                    phone: _this3.phone,
                    password: _this3.password,
                    verify_code: _this3.verify_code,
                    openid: _this3.openid
                  });
                case 4:
                  res = _context.sent;
                  setTimeout(function () {
                    _this3.loading = false;
                  }, 300);
                  if (!res.success) {
                    _context.next = 15;
                    break;
                  }
                  _this3.$vux.toast.text(i18n.tc("180"));
                  _this3._Authorization(res.data);
                  _this3.rememberPwd(); // 记住账号密码
                  _context.next = 12;
                  return _this3._ApiSession();
                case 12:
                  if (_this3.appointInfo) {
                    _this3.$router.replace({
                      name: 'ServiceDetail',
                      query: {
                        id: _this3.appointInfo.id,
                        productId: _this3.appointInfo.productId,
                        cpId: _this3.appointInfo.cpId
                      }
                    });
                    _this3._appointInfo(null);
                  } else if (_this3.user.type === 1 &&
                  // 评价入口
                  _this3.user.oid && _this3.user.evaluateState === 0 // 评价状态 未评价
                  ) {
                    // 走评价工单
                    _this3.$router.replace({
                      name: 'ProjectDetailComment',
                      params: {
                        oid: _this3.user.oid
                      }
                    });
                  } else if ((_this3$$route = _this3.$route) !== null && _this3$$route !== void 0 && (_this3$$route$query = _this3$$route.query) !== null && _this3$$route$query !== void 0 && _this3$$route$query.path) {
                    _this3.$router.replace({
                      path: _this3.$route.query.path
                    });
                  } else {
                    // 普通登录
                    _this3.$router.replace({
                      name: 'Home'
                    });
                  }
                  _context.next = 16;
                  break;
                case 15:
                  _this3.$vux.toast.text(res.message);
                case 16:
                  _context.next = 19;
                  break;
                case 18:
                  _this3.$vux.toast.text(valid.msg);
                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 记住密码
    rememberPwd: function rememberPwd() {
      if (this.remember && this.type === 1) {
        // 开启记住密码 并且使用账号密码登录
        var temp = JSON.stringify({
          phone: this.phone,
          password: this.password
        });
        localStorage.setItem('user', temp, function (e) {
          if (e.result === 'success') {
            console.log('储存user');
          }
        });
      } else {
        // 只记住手机号
        var _temp = JSON.stringify({
          phone: this.phone,
          password: ''
        });
        localStorage.setItem('user', _temp, function (e) {
          if (e.result === 'success') {
            console.log('储存user');
          }
        });
        // localStorage.removeItem('user')
      }
    },
    // 获取验证码
    getVerify: function getVerify() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this4.checkPhone(_this4.phone)) {
                  _context2.next = 3;
                  break;
                }
                _this4.$vux.toast.text(i18n.tc("173"));
                return _context2.abrupt("return", false);
              case 3:
                _this4.waitAMoment();
                _this4.wait = 59;
                _context2.next = 7;
                return apismsvalid({
                  phone: _this4.phone
                });
              case 7:
                res = _context2.sent;
                if (!res.success) {
                  _this4.wait = 0;
                  _this4.$vux.toast.text(res.message);
                }
              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 计时器
    waitAMoment: function waitAMoment() {
      var _this5 = this;
      this.clear = setTimeout(function () {
        _this5.wait--;
        _this5.waitAMoment();
        if (_this5.wait < 1) {
          clearTimeout(_this5.clear);
          _this5.wait = 61;
        }
      }, 1000);
    },
    // 验证手机类型
    checkPhone: function checkPhone(phone) {
      if (phone.match(/[0-9-()（）]{6,15}/)) {
        return true;
      } else {
        return false;
      }
    }
  })
};